import {isFSA} from 'flux-standard-action'
import {SEND_SESSION_START_FINISH, START_SESSION, START_SESSION_FINISH} from '../constants/ActionTypes'
import {actions as kandyActions} from 'kandy-redux'
import t from "../localization"
import { chatActions} from '../actions'
import _ from 'lodash'
let middleware = ({dispatch, getState}) => {
    return next => action => {
        if (isFSA(action)) {
            if (action.type === SEND_SESSION_START_FINISH) {
                if (action.payload.response && action.payload.response.customerFullUserId) {
                    dispatch(kandyActions.sendMessage(action.payload.response.customerFullUserId, action.payload.message ? action.payload.message : t('Session::Hello')))
                }
            }
            if (action.type === START_SESSION) {
                let appState = getState().app
                let customers = appState.serviceRequests.customers;
                let selectedCustomer = appState.selectedCustomer;
                let currentRequestArr = _.filter(customers, function (item) {
                    return item._id == selectedCustomer;
                })
                let currentRequest;
                if (currentRequestArr.length > 0) {
                    currentRequest = currentRequestArr[0];
                }
            }
            else if (action.type === START_SESSION_FINISH) {
                if (!action.error) {
                    let company = getState().company
                    let serviceRequest = action.payload.serviceRequest

                    dispatch(chatActions.getChatHistory(serviceRequest.userInfo.email, company.id));
                }
            }

            return next(action)
        }
    }
}

export default middleware
